export default __webpack_public_path__ + "static/media/banner4.da68c766.jpg";